import axios from 'axios';
import { Configuration, ParticipantNetworkingApi } from '@/api';

// EV-85: клиент публичного API веб-нетворкинга участника.
// Свой axios без перехватчика AppContext: ошибки участника (нет сессии, неверный код)
// не должны разлогинивать/редиректить админку.

const SESSION_HEADER = 'X-Participant-Session';
const storageKey = token => `participantSession:${token}`;

export const loadSession = token => {
  try {
    return localStorage.getItem(storageKey(token)) || null;
  } catch (e) {
    return null;
  }
};

export const saveSession = (token, sessionToken) => {
  try {
    if (sessionToken) {
      localStorage.setItem(storageKey(token), sessionToken);
    } else {
      localStorage.removeItem(storageKey(token));
    }
  } catch (e) {
    // приватный режим браузера — сессия проживёт до перезагрузки страницы
  }
};

// onSessionLost — сессия истекла/отозвана: страница возвращается к входу.
export const createParticipantApi = (sessionToken, onSessionLost) => {
  const instance = axios.create({
    headers: sessionToken ? { [SESSION_HEADER]: sessionToken } : {},
  });
  instance.interceptors.response.use(
    response => response,
    error => {
      if (sessionToken && onSessionLost && errorCode(error) === 'PARTICIPANT_SESSION_REQUIRED') {
        onSessionLost();
      }
      return Promise.reject(error);
    }
  );
  return new ParticipantNetworkingApi(new Configuration({ basePath: window.location.origin }), undefined, instance);
};

export const errorCode = error => error?.response?.data?.error;

// Текст ошибки для пользователя: сервер отдаёт уже отформатированное сообщение.
export const errorMessage = error => {
  const data = error?.response?.data;
  if (!data) {
    return 'Не удалось связаться с сервером. Проверьте интернет и попробуйте ещё раз.';
  }
  if (data.errors && data.errors.length) {
    return data.errors.map(e => e.message).join('\n');
  }
  return data.message || 'Что-то пошло не так';
};

// Ошибки валидации по полям: { 'extended.company': 'Поле обязательно', ... }
export const fieldErrors = error => {
  const data = error?.response?.data;
  if (!data) return {};
  const list = data.errors || [data];
  const ret = {};
  list.forEach(e => {
    const field = e.args && e.args.field;
    if (field) ret[field] = e.message;
  });
  return ret;
};

export const imageUrl = imageId => (imageId ? '/api/image/' + imageId : undefined);
